export default "__VITE_ASSET__adb682fa__"